// src/redux/settingsSlice.js
import { createSlice } from '@reduxjs/toolkit';

// New nested settings shape requested by user.
// Each symbol type contains symbol color (color/previewColor) and
// wiring color (wireColor/wirePreviewColor).
const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    machine: {
      // Symbol colors
      color: "#2777BB",
      previewColor: "#2777BB",
      // Wire colors
      wireColor: "#2777BB",
      wirePreviewColor: "#2777BB"
    },
    socket: {
      color: "#c20000ff",
      previewColor: "#fc3939cb",
      wireColor:  "#c20000ff",
      wirePreviewColor: "#fc3939cb"
    },
    lightingSwitch: {
      color: "#CD6928",
      previewColor: "#CD6928",
      wireColor:"#CD6928",
      wirePreviewColor: "#CD6928"
    },
    fixture: {
      color: "#CD6928",
      previewColor: "#CD6928",
      wireColor: "#CD6928",
      wirePreviewColor: "#CD6928"
    },

    // Panel related settings
    mainPanel: {
      color: "#990000",
      previewColor: "#990000",
      wireColor: "#990000",
      wirePreviewColor: "#990000"
    },
    panel: {
      color:"#990000",
      previewColor: "#990000",
      wireColor: "#990000",
      wirePreviewColor: "#990000"
    }
    ,
    // Low current (bell, bell button, other low-voltage systems)
    lowCurrent: {
      color: "#ff4577",
      previewColor: "#ff4577",
      wireColor: "#ff4577",
      wirePreviewColor: "#ff4577"
    }
  },
  reducers: {
    // Machine
    setMachineColor: (state, action) => { state.machine.color = action.payload; },
    setMachinePreviewColor: (state, action) => { state.machine.previewColor = action.payload; },
    setMachineWireColor: (state, action) => { state.machine.wireColor = action.payload; },
    setMachineWirePreviewColor: (state, action) => { state.machine.wirePreviewColor = action.payload; },

    // Socket
    setSocketColor: (state, action) => { state.socket.color = action.payload; },
    setSocketPreviewColor: (state, action) => { state.socket.previewColor = action.payload; },
    setSocketWireColor: (state, action) => { state.socket.wireColor = action.payload; },
    setSocketWirePreviewColor: (state, action) => { state.socket.wirePreviewColor = action.payload; },

    // Lighting switch
    setLightingSwitchColor: (state, action) => { state.lightingSwitch.color = action.payload; },
    setLightingSwitchPreviewColor: (state, action) => { state.lightingSwitch.previewColor = action.payload; },
    setLightingSwitchWireColor: (state, action) => { state.lightingSwitch.wireColor = action.payload; },
    setLightingSwitchWirePreviewColor: (state, action) => { state.lightingSwitch.wirePreviewColor = action.payload; },

    // Fixture
    setFixtureColor: (state, action) => { state.fixture.color = action.payload; },
    setFixturePreviewColor: (state, action) => { state.fixture.previewColor = action.payload; },
    setFixtureWireColor: (state, action) => { state.fixture.wireColor = action.payload; },
    setFixtureWirePreviewColor: (state, action) => { state.fixture.wirePreviewColor = action.payload; },

    // Panel
    setMainPanelColor: (state, action) => { state.mainPanel.color = action.payload; },
    setMainPanelPreviewColor: (state, action) => { state.mainPanel.previewColor = action.payload; },
    setPanelColor: (state, action) => { state.panel.color = action.payload; },
    setPanelPreviewColor: (state, action) => { state.panel.previewColor = action.payload; },
    // Low current
    setLowCurrentColor: (state, action) => { state.lowCurrent.color = action.payload; },
    setLowCurrentPreviewColor: (state, action) => { state.lowCurrent.previewColor = action.payload; },
    setLowCurrentWireColor: (state, action) => { state.lowCurrent.wireColor = action.payload; },
    setLowCurrentWirePreviewColor: (state, action) => { state.lowCurrent.wirePreviewColor = action.payload; },
  }
});

export const {
  setMachineColor,
  setMachinePreviewColor,
  setMachineWireColor,
  setMachineWirePreviewColor,

  setSocketColor,
  setSocketPreviewColor,
  setSocketWireColor,
  setSocketWirePreviewColor,

  setLightingSwitchColor,
  setLightingSwitchPreviewColor,
  setLightingSwitchWireColor,
  setLightingSwitchWirePreviewColor,

  setFixtureColor,
  setFixturePreviewColor,
  setFixtureWireColor,
  setFixtureWirePreviewColor,

  setMainPanelColor,
  setMainPanelPreviewColor,
  setPanelColor,
  setPanelPreviewColor
  ,
  setLowCurrentColor,
  setLowCurrentPreviewColor,
  setLowCurrentWireColor,
  setLowCurrentWirePreviewColor
} = settingsSlice.actions;

export default settingsSlice.reducer;
